export class ExtendedAttributeFilterValue {
    value: string;
    translationKey: string;

    constructor(query: { value: string; translation_key: string }) {
        this.value = query.value;
        this.translationKey = query.translation_key;
    }
}
